import { useContext, useEffect, useState } from "react";

import {
  Container,
  FormControlLabel,
  Grid,
  IconButton,
  Switch,
  Typography,
} from "@material-ui/core";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import AddIcon from "@material-ui/icons/Add";
import { Settings } from "@material-ui/icons";
import { useHistory } from "react-router";

import HeaderModule from "../../../components/header/HeaderModule";
import { PainelContainer, TableContent } from "./styles/Fornecedor";
import { QueryParamsContext } from "../../../context/QueryParamsContext";
import TextFieldErp from "../../../components/basics/TextFieldErp";
import Btn from "../../../components/buttons/Btn";
import Loading from "../../../components/basics/Loading";

import RedBall from "../../../assets/imgs/bolinha-vermelha.png";
import GreenBall from "../../../assets/imgs/bolinha-verde.png";
import WhatsappButton from "../../../components/whatsappButton/WhatsappButton";

import { BallContainer } from "./styles/Fornecedor";
import SpeedDialErp from "../../../components/speeddial/SpeedDialErp";
import BigDataTable from "../../../components/tables/BigDataTable";
import MaskService from "../../../utils/mask/maskService";
import ModalParameters from "../../../patterns/modals/modalparameters/ModalParameters";
import { findUsuarios } from "../../../repositories/qerpapi/erp/acesso/v1/UsuarioRepository";
import { notify } from "../../../utils/notify";
import { GlobalVariables } from "../../../GlobalVariables";

let typingTimer = null;
const FornecedorCadastro = () => {
  // eslint-disable-next-line
  const [reload, setReload] = useState(false);
  const [textFilter, setTextFilter] = useState("");
  const [showOnlyActives, setShowOnlyActives] = useState(true);
  const [queryOrWhere, setQueryOrWhere] = useState(null);
  const [queryOrWhereTranslate, setQueryOrWhereTranslate] = useState(null);
  const [queryWhere, setQueryWhere] = useState({ ativo: "" });
  // eslint-disable-next-line
  const [viewLoading, setViewLoading] = useState(false);

  const { queryParams } = useContext(QueryParamsContext);
  const { push } = useHistory();

  const columns = [
    {
      id: "acoes",
      label: "Ações",
      align: "center",
      format: (item) => {
        return (
          <SpeedDialErp
            actions={[
              {
                icon: <EditOutlinedIcon />,
                name: "Editar",
                action: () =>
                  push(
                    "cadastro?empresa_cnpj=" +
                      queryParams.empresa_cnpj +
                      "&empresa_id=" +
                      queryParams.empresa_id,
                    { item }
                  ),
              },
            ]}
          />
        );
      },
    },
    {
      id: "id",
      label: "ID",
    },
    {
      id: "razao",
      label: "Razão",
    },
    {
      id: "apelido",
      label: "Fantasia",
    },
    {
      id: "cgc",
      label: "CNPJ/CPF/CÓD",
      format: (item) => {
        let clientInfo,
          replacedInfo = item?.cgc?.replace(/[^0-9]+/g, "") ?? "-";

        if (replacedInfo.length === 11)
          clientInfo = MaskService.toMask("cpf", replacedInfo);
        else if (replacedInfo.length === 14)
          clientInfo = MaskService.toMask("cnpj", replacedInfo);
        else clientInfo = replacedInfo;

        return clientInfo;
      },
    },
    {
      id: "email1",
      label: "E-mail",
    },
    {
      id: "endereco",
      label: "Município",
      format: (item) => {
        return `${item?.cidade} - ${item?.estado?.estado}`;
      },
    },
    {
      id: "telefone1",
      label: "Telefone",
      format: (item) =>
        item.telefone1 && item.ddd1
          ? MaskService.toMask("cel-phone", item.ddd1 + item.telefone1)
          : item.telefone1
          ? MaskService.toMask("cel-phone", "00" + item.telefone1)
          : "",
    },
    {
      id: "celular",
      label: "Celular",
      format: (item) =>
        item.whatsapp_ativo === 1 && <WhatsappButton celular={item.celular} />,
    },
    {
      id: "ativo",
      label: "Ativo",
      align: "center",
      format: (value) =>
        value.ativo === "S" ? (
          <BallContainer>
            <img src={GreenBall} alt="Fornecedor ativo" />
          </BallContainer>
        ) : (
          <BallContainer>
            <img src={RedBall} alt="Fornecedor inativo" />
          </BallContainer>
        ),
    },
  ];

  useEffect(() => {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(() => {
      setQueryOrWhere({
        razao: encodeURIComponent(`${textFilter}`),
        apelido: encodeURIComponent(`${textFilter}`),
        email1: encodeURIComponent(`${textFilter}`),
        telefone1: encodeURIComponent(`${textFilter}`),
        celular: encodeURIComponent(`${textFilter}`),
      });

      setQueryOrWhereTranslate({
        cgc: `${textFilter}`,
      });
    }, 1500);
  }, [textFilter]);

  useEffect(() => {
    setQueryWhere({ ativo: showOnlyActives ? "S" : "N" });
  }, [showOnlyActives]);

  const [modalParametersOpen, setModalParametersOpen] = useState(false);
  const [ableToOpenModal, setAbleToOpenModal] = useState(false);

  useEffect(() => {
    if (!queryParams.usuario_id || !queryParams.empresa_cnpj) return;

    findUsuarios(
      queryParams.empresa_cnpj,
      queryParams.usuario_id,
      "grupos"
    ).then((res) => {
      if (!res.success)
        return notify("Não foi possível encontrar o grupo de usuário.");

      const permission =
        (res.data?.grupos || []).some((el) => el.id === 32) || false;
      setAbleToOpenModal(permission);
    });
  }, [queryParams.usuario_id, queryParams.empresa_cnpj]);

  return (
    <>
      {modalParametersOpen && (
        <ModalParameters
          open={modalParametersOpen}
          setOpen={setModalParametersOpen}
          entity="fornecedores"
        />
      )}

      <Loading open={viewLoading} />
      <HeaderModule
        title="CADASTRO DE FORNECEDORES"
        videoId={GlobalVariables.screenVideosIds.cadastroFornecedor}
        receivedChild={
          <Grid item>
            {ableToOpenModal && (
              <IconButton
                onClick={() => setModalParametersOpen((current) => !current)}
              >
                <Settings />
              </IconButton>
            )}
          </Grid>
        }
      />

      <PainelContainer />
      <Container maxWidth="xl">
        <Grid container spacing={3}>
          <Grid item container justify="space-between" alignItems="flex-end">
            <Grid item xs={12} sm={12} md={7}>
              <TextFieldErp
                value={textFilter}
                setValue={setTextFilter}
                label="Busque por Razão, Fantasia, CPF/CNPJ/CÓD, Email ou Telefone"
                variant="filled"
              />
            </Grid>

            <Grid item xs={6} sm={6} md={3} lg={3}>
              <FormControlLabel
                control={
                  <Switch
                    checked={showOnlyActives}
                    onChange={() => setShowOnlyActives((current) => !current)}
                    color="primary"
                  />
                }
                label="Ativos"
                labelPlacement="end"
              />
            </Grid>

            <Grid item flex={1}>
              <Btn
                label="Novo"
                startIcon={<AddIcon />}
                onClick={() => push("cadastro")}
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <TableContent>
              <BigDataTable
                tableTitle=""
                route="prouser/fornecedores/v1"
                columns={columns}
                where={queryWhere}
                orWhere={queryOrWhere}
                orWhereTranslate={queryOrWhereTranslate}
                reload={reload}
                include="planocontas,centrocusto,contatos,estado"
              />
            </TableContent>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default FornecedorCadastro;
